var MpPageLegalAdviser;

(function() {
    if (!document.querySelector('#vue-body-legaladviser')) {
        return;
    }

    Vue.component('flat-pickr', VueFlatpickr);

    MpPageLegalAdviser = new Vue({
        el: '#vue-body-legaladviser',
        mixins: [MpBaseLegalAdviser],
        data: {
            LEGALADVISER_URL: '/legaladviser/format/json/page/',

            DATE_PICKER_CONFIG: {
                mode: 'range',
                defaultDate: null,
                maxDate: 'today',
                dateFormat: 'Y-m-d',
                altInput: true,
                altFormat: 'd/m/Y',
                locale: COUNTRY, /// Global variable injected via php BaseController
                shorthandCurrentMonth: true
            },

            word: '',

            dateRange: null,
            dateStart: '',
            dateEnd: '',
            dt_start: '',
            dt_end: '',
            dateAll: null,

            categories: [],
            filters: '',

            totalResultsTPL: '',
            totalItems: 0,
            categoryCheckList: [],

            allChecked: false,
            isSearchActive: SHOW_ADVANCED,
        },
        computed: {
            isFilteredByCategory: function() {
                return this.categories.length;
            },

            dataFilters: function() {

                return Serializer.serialize({
                    'date-start': this.dateStart,
                    'date-end': this.dateEnd,
                    'dt_start': this.dt_start,
                    'dt_end': this.dt_end,
                    'word': this.word,
                    'categories': this.categories,
                    'filters': this.filters
                });
            }
        },
        methods: {

            addCategoryCheck: function(checkItem) {
                this.categoryCheckList.push(checkItem);

                if (checkItem.getAttribute('checked')) {
                    this.categories.push(checkItem.value);
                }
            },

            setAllChecks: function() {
                var i;
                this.allChecked = !this.allChecked;
                for (i=0; i<this.categoryCheckList.length; i++) {
                    this.categoryCheckList[i].checked = this.allChecked;
                }
            },

            showFilters: function() {
                this.isSearchActive = !this.isSearchActive;
            },

            resetFilters: function() {
                this.word = '';
                this.setAllDates(true);
                this.categories = [];

                this.filters = 'reset'; // to reset server session filters
                this.loadItems();
            },

            setAllDates: function(state) {
                this.dateAll = state;

                if (this.dateAll) {
                    this.dateRange = null;
                    this.dateStart = '';
                    this.dateEnd = '';
                    this.dt_start = '';
                    this.dt_end = '';
                }
                },

            onDateChange: function(dateSelection) {
                if (dateSelection.length === 2) {
                    this.setAllDates(false);

                    this.dateStart = DateHelper.getDateObjString(dateSelection[0]);
                    this.dateEnd = DateHelper.getDateObjString(dateSelection[1]);
                    this.dt_start = this.dateStart;
                    this.dt_end = this.dateEnd;
                }
            },

            loadItems: function(isPagination) {
                if (!isPagination && this.page !== 1) {
                    this.setPage(1);
                }

                // Set proper filters value depending the request type
                this.filters = (!isPagination) ? (this.filters || 'ok') : '';

                axios
                    .post(this.LEGALADVISER_URL + this.page, this.dataFilters)
                    .then(this.onItemsLoaded)
                    .catch(function(error) {
                        console.log(error);
                    });
            },

            sendForm: function() {
                // TODO: validate filters?
                if (true) {
                    this.loadItems();
                }
            }
        },
        filters: {},

        mounted: function() {
            this.$refs.ssrItemList.querySelectorAll('.js-item').forEach(this.addDomItem);
            this.$refs.ssrCategoryList.querySelectorAll('.js-category-check').forEach(this.addCategoryCheck);

            this.word = this.$refs.word.getAttribute('data-init');
            this.totalResultsTPL = this.$refs.ssrTotalItems.getAttribute('data-tpl');
            this.totalItems = this.$refs.ssrTotalItems.getAttribute('data-total');

            this.dateRange = (DATE_START_USER && DATE_END_USER) ? [DATE_START_USER, DATE_END_USER] : null;
            this.dateStart = DATE_START_USER;
            this.dateEnd = DATE_END_USER;
            this.dt_start = this.$refs.dt_start.getAttribute('data-init');
            this.dt_end = this.$refs.dt_end.getAttribute('data-init');
            this.filters = this.$refs.filters.getAttribute('data-init');
            this.dateAll = (this.$refs.dateAll.getAttribute('data-init') == true);
            this.setAllDates(this.dateAll);
        },

    });

})();
